var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.88878 18.1413V16.0009C9.88878 15.4545 10.3584 15.0116 10.9378 15.0116H13.0556C13.3338 15.0116 13.6006 15.1158 13.7974 15.3014C13.9941 15.4869 14.1046 15.7385 14.1046 16.0009V18.1413C14.1029 18.3685 14.1973 18.5869 14.367 18.7481C14.5367 18.9093 14.7676 19 15.0085 19H16.4533C17.1282 19.0016 17.7759 18.75 18.2537 18.3006C18.7315 17.8511 19 17.2409 19 16.6045V10.5068C19 9.99272 18.7584 9.50509 18.3402 9.17527L13.4251 5.47311C12.5701 4.82399 11.345 4.84495 10.5156 5.52289L5.71254 9.17527C5.27465 9.49537 5.01293 9.98445 5 10.5068V16.5983C5 17.9247 6.14018 19 7.54665 19H8.95853C9.4588 19 9.86537 18.6194 9.86899 18.1476L9.88878 18.1413Z",
    fill: "#9E9E9E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.1f44061776c8fa413d77831801b354f3.svg";
export { ForwardRef as ReactComponent };